import {
  CButton,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CInput,
  CLabel,
  CRow,
  CSelect,
  CSpinner,
  CTextarea,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { apiCall } from "src/_apiConfig/apiCall";
import { useParams, useHistory } from "react-router-dom";
import Auth from "src/auth";

const EditTender = () => {
  const { authenticated } = Auth();
  const year = 1900;
  const history = useHistory();
  const [loading, setloading] = useState(false);
  const [tenderId, settenderId] = useState();
  const [tenderNo, settenderNo] = useState();
  const [details, setdetails] = useState();
  const [paymentSlots, setpaymentSlots] = useState(null);
  const [rebate, setrebate] = useState();
  const [lateFeePerDay, setlateFeePerDay] = useState();
  const [securityDepositAmount, setsecurityDepositAmount] = useState();
  const [securityDepositDay, setsecurityDepositDay] = useState();
  const [canModified, setcanModified] = useState();
  const [dueDates, setdueDates] = useState([]);
  const [dueDatePayment, setdueDatePayment] = useState([]);
  const [terminateDate, setterminateDate] = useState([]);
  const [splitedDueDates, setsplitedDueDates] = useState([]);
  const [purchaseDate, setPurchaseDate] = useState();
  const [totalLots, settotalLots] = useState();
  const [collectionSeason, setcollectionSeason] = useState(
    new Date().getFullYear()
  );
  const [leasePeriodDate, setleasePeriodDate] = useState();
  const [TenderTypes, setTenderTypes] = useState();
  const [clauseSlots, setclauseSlots] = useState(0);
  const [clausesData, setclausesData] = useState([]);
  const [clauseData, setclauseData] = useState();
  const [clauseId, setclauseId] = useState([]);
  const [godownInsuraceFromDate, setGodownInsuraceFromDate] = useState();
  const [godownInsuraceToDate, setGodownInsuraceToDate] = useState();
  const [
    lastDateForSubmittingInsurancePolicy,
    setLastDateForSubmittingInsurancePolicy,
  ] = useState();
  const [extraAmountInsuranceLastDate, setExtraAmountInsuranceLastDate] =
    useState();
  const [lateFeeInsuranceAmount, setLateFeeInsuranceAmount] = useState();
  const [penaltyAmount, setPenaltyAmount] = useState();
  const [TerminationAgreementStartDate, setTerminationAgreementStartDate] =
    useState();
  const [TerminationAgreementEndDate, setTerminationAgreementEndDate] =
    useState();
  const [AfterTerminationDate, setAfterTerminationDate] = useState();
  const [RestorationFee, setRestorationFee] = useState();
  const [TerminationUpToDate, setTerminationUpToDate] = useState();
  const [TerminationLateFeePerDay, setTerminationLateFeePerDay] = useState();
  const [PruningStartDate, setPruningStartDate] = useState();
  const [PruningEndDate, setPruningEndDate] = useState();
  const [AgreementStartDate, setAgreementStartDate] = useState();
  const [AgreementUptoDate, setAgreementUptoDate] = useState();
  const [periodEndingDate, setperiodEndingDate] = useState();
  const [representativeDetailsLastDate, setrepresentativeDetailsLastDate] =
    useState();
  const [paymentLastDate, setpaymentLastDate] = useState();
  const [doubleLockUptoDate, setdoubleLockUptoDate] = useState();
  const [throughLetterDate, setthroughLetterDate] = useState();
  const [keepingInGodownDate, setkeepingInGodownDate] = useState();
  const [godownRentPaymentUptoDate, setgodownRentPaymentUptoDate] = useState();
  const [secondAgreementExtentionDate, setsecondAgreementExtentionDate] =
    useState();
  const [additionalSDLastDate, setadditionalSDLastDate] = useState();
  const [HSN, setHSN] = useState();
  const [godownRentPerBag, setGodownRentPerBag] = useState();
  const [ChequeReplacementLastDate, setChequeReplacementLastDate] = useState();
  const [FirstTransferLastDate, setFirstTransferLastDate] = useState();
  const [SecondTransferStartDate, setSecondTransferStartDate] = useState();
  const [SecondTransferEndDate, setSecondTransferEndDate] = useState();

  let changeDuedatePayment = [];
  let dueDatesArr = [];
  let changeDueDatesArr = [];
  let { id, mode } = useParams();

  const getDistrictForEdit = async () => {
    setloading(true);
    const header = new Headers();
    const response = await apiCall(
      `Tender?$filter=tenderId%20eq%20${id}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response.json();
    if (response.status === 200) {
      debugger;
      settenderId(jsonobj[0].tenderId);
      settenderNo(jsonobj[0].tenderNo);
      setdetails(jsonobj[0].details);
      setpaymentSlots(jsonobj[0].paymentSlots);
      setrebate(jsonobj[0].rebate);
      setlateFeePerDay(jsonobj[0].lateFeePerDay);
      setsecurityDepositAmount(jsonobj[0].securityDepositAmount);
      setsecurityDepositDay(jsonobj[0].securityDepositDay);
      setcanModified(jsonobj[0].canModified);
      setPurchaseDate(jsonobj[0].purchaseDate.split("T")[0]);
      setleasePeriodDate(jsonobj[0].leasePeriodDate.split("T")[0]);
      setcollectionSeason(jsonobj[0].collectionSeason);
      settotalLots(jsonobj[0].totalLots);
      setTenderTypes(jsonobj[0].tenderType);
      setGodownInsuraceFromDate(
        jsonobj[0].godownInsuraceFromDate.split("T")[0]
      );
      setGodownInsuraceToDate(jsonobj[0].godownInsuraceToDate.split("T")[0]);
      setLastDateForSubmittingInsurancePolicy(
        jsonobj[0].lastDateForSubmittingInsurancePolicy.split("T")[0]
      );
      setExtraAmountInsuranceLastDate(
        jsonobj[0].extraAmountInsuranceLastDate.split("T")[0]
      );
      setLateFeeInsuranceAmount(jsonobj[0].lateFeeInsuranceAmount);
      dueDatesArr = jsonobj[0].paymentDueDates;
      setPenaltyAmount(jsonobj[0].penaltyAmount);
      setTerminationAgreementStartDate(
        jsonobj[0].terminationAgreementStartDate.split("T")[0]
      );
      setTerminationAgreementEndDate(
        jsonobj[0].terminationAgreementEndDate.split("T")[0]
      );
      setAfterTerminationDate(jsonobj[0].afterTerminationDate.split("T")[0]);
      setRestorationFee(jsonobj[0].restorationFee);
      setTerminationUpToDate(jsonobj[0].terminationUpToDate.split("T")[0]);
      setTerminationLateFeePerDay(jsonobj[0].terminationLateFeePerDay);
      setPruningStartDate(jsonobj[0].pruningStartDate.split("T")[0]);
      setPruningEndDate(jsonobj[0].pruningEndDate.split("T")[0]);
      setAgreementStartDate(jsonobj[0].agreementStartDate.split("T")[0]);
      setAgreementUptoDate(jsonobj[0].agreementUptoDate.split("T")[0]);
      setperiodEndingDate(jsonobj[0].periodEndingDate.split("T")[0]);
      setrepresentativeDetailsLastDate(
        jsonobj[0].representativeDetailsLastDate.split("T")[0]
      );
      setpaymentLastDate(jsonobj[0].paymentLastDate.split("T")[0]);
      setdoubleLockUptoDate(jsonobj[0].doubleLockUptoDate.split("T")[0]);
      setthroughLetterDate(jsonobj[0].throughLetterDate.split("T")[0]);
      setkeepingInGodownDate(jsonobj[0].keepingInGodownDate.split("T")[0]);
      setgodownRentPaymentUptoDate(
        jsonobj[0].godownRentPaymentUptoDate.split("T")[0]
      );
      setsecondAgreementExtentionDate(
        jsonobj[0].secondAgreementExtentionDate === null
          ? ""
          : jsonobj[0].secondAgreementExtentionDate.split("T")[0]
      );
      setadditionalSDLastDate(
        jsonobj[0].additionalSDLastDate === null
          ? ""
          : jsonobj[0].additionalSDLastDate.split("T")[0]
      );
      setHSN(jsonobj[0].hsn === null ? "" : jsonobj[0].hsn);
      setChequeReplacementLastDate(
        jsonobj[0].chequeReplacementLastDate === null
          ? ""
          : jsonobj[0].chequeReplacementLastDate.split("T")[0]
      );
      setFirstTransferLastDate(
        jsonobj[0].firstTransferLastDate === null
          ? ""
          : jsonobj[0].firstTransferLastDate.split("T")[0]
      );
      setSecondTransferStartDate(
        jsonobj[0].secondTransferStartDate === null
          ? ""
          : jsonobj[0].secondTransferStartDate.split("T")[0]
      );
      setSecondTransferEndDate(
        jsonobj[0].secondTransferEndDate === null
          ? ""
          : jsonobj[0].secondTransferEndDate.split("T")[0]
      );
      setGodownRentPerBag(jsonobj[0].godownRentPerBag);
      setsplitedDueDates(dueDatesArr);

      changeDuedatePayment = jsonobj[0].paymentDueDates.map(
        (e) => e.paymentComplete
      );
      changeDueDatesArr = jsonobj[0].paymentDueDates.map(
        (data) => data.paymentDueDate.split("T")[0]
      );
      setdueDates(changeDueDatesArr);
      setdueDatePayment(changeDuedatePayment);
      changeDueDatesArr = jsonobj[0].paymentDueDates.map(
        (data) => data.terminationDate.split("T")[0]
      );
      setterminateDate(changeDueDatesArr);
      setclauseData(jsonobj[0].sanctionClauses[0]);
      setclauseSlots(jsonobj[0].sanctionClauses.length - 1);
      const clauseArr = jsonobj[0].sanctionClauses.map((data, i) => ({
        id: i,
        clause: data,
      }));
      setclausesData(clauseArr.filter((data) => data.id !== 0));

      setclauseId(
        clauseArr.filter((data) => data.id !== 0).map((data) => data.id)
      );

      const newclause = [
        ...clausesData,
        { id: clauseId[clauseId.length - 1] + 1, clause: "" },
      ];
    }

    setloading(false);
  };

  useEffect(() => {
    getDistrictForEdit();
    console.log(mode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const PostBackFunction = async () => {
  //   alert("inside function");
  //   history.push("/test");
  // };

  const postTenderData = async (e) => {
    e.preventDefault();
    const finalClause = [{ id: 0, clause: clauseData }, ...clausesData];
    const finalStringArr = finalClause.map((data) => data.clause);

    setloading(true);
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      "Tender/update",
      "PUT",
      header,
      JSON.stringify({
        tenderId: Number(tenderId),
        tenderNo: tenderNo,
        details: details,
        paymentSlots: paymentSlots,
        rebate: rebate,
        purchaseDate: purchaseDate,
        lateFeePerDay: lateFeePerDay,
        securityDepositAmount: securityDepositAmount,
        securityDepositDay: securityDepositDay,
        paymentDueDates: splitedDueDates,
        canModified: canModified,
        totalLots: totalLots,
        collectionSeason: collectionSeason,
        leasePeriodDate: leasePeriodDate,
        sanctionClauses: finalStringArr[0] === undefined ? [] : finalStringArr,
        godownInsuraceFromDate: godownInsuraceFromDate,
        godownInsuraceToDate: godownInsuraceToDate,
        lastDateForSubmittingInsurancePolicy:
          lastDateForSubmittingInsurancePolicy,
        extraAmountInsuranceLastDate: extraAmountInsuranceLastDate,
        lateFeeInsuranceAmount: lateFeeInsuranceAmount,
        penaltyAmount: penaltyAmount,
        terminationAgreementStartDate: TerminationAgreementStartDate,
        terminationAgreementEndDate: TerminationAgreementEndDate,
        afterTerminationDate: AfterTerminationDate,
        restorationFee: RestorationFee,
        terminationUpToDate: TerminationUpToDate,
        terminationLateFeePerDay: TerminationLateFeePerDay,
        pruningStartDate: PruningStartDate,
        pruningEndDate: PruningEndDate,
        agreementStartDate: AgreementStartDate,
        agreementUptoDate: AgreementUptoDate,
        periodEndingDate,
        representativeDetailsLastDate,
        paymentLastDate,
        doubleLockUptoDate,
        throughLetterDate,
        keepingInGodownDate,
        godownRentPaymentUptoDate,
        secondAgreementExtentionDate,
        additionalSDLastDate,
        godownRentPerBag,
        HSN,
        TenderType: TenderTypes,
        ChequeReplacementLastDate,
        FirstTransferLastDate,
        SecondTransferStartDate,
        SecondTransferEndDate,
      })
    );
    await response.json();

    if (response.status === 200) {
      setloading(false);
      const redirectURL =
        authenticated.role === "CGMF" ? "/tender/tenderlist" : "/tenderlist";
      history.push(redirectURL);
      // alert('RECORD UPDATED SUCCESSFULLY');
    }
  };
  let one = (
    <CRow className="mb-3">
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment due date 1
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={dueDates[0] === null ? " " : dueDates[0]}
          onChange={(e) => {
            //for changing textbox date

            setdueDates(dueDatesArr);
            if (splitedDueDates.length > 0) {
              dueDatesArr = splitedDueDates;
              dueDatesArr[0].paymentDueDate = e.target.value;
              setsplitedDueDates(dueDatesArr);
            } else {
              dueDatesArr.push({
                paymentDueDate: e.target.value,
                paymentComplete:
                  dueDatePayment[0] === null ? 0 : dueDatePayment[0],
                terminationDate:
                  terminateDate[0] === null ? " " : terminateDate[0],
              });
              setsplitedDueDates(dueDatesArr);
            }
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment Complete
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          min="0"
          max="100"
          type="number"
          value={
            dueDatePayment[0] === null
              ? null
              : dueDatePayment[0] > 100
              ? 100
              : dueDatePayment[0] < 0
              ? 0
              : dueDatePayment[0]
          }
          placeholder=""
          onChange={(e) => {
            if (e.target.value > 100) {
              dueDatesArr[0] = 100;
            } else if (e.target.value < 0) {
              dueDatesArr[0] = 0;
            } else {
              dueDatesArr = [];
            }
            setdueDatePayment(dueDatesArr);
            if (splitedDueDates.length > 0) {
              dueDatesArr = splitedDueDates;
              dueDatesArr[0].paymentComplete = Number(
                e.target.value > 100
                  ? 100
                  : e.target.value < 0
                  ? 0
                  : e.target.value
              );
            } else {
              dueDatesArr = [];
              dueDatesArr.push({
                paymentDueDate: dueDates[0] === null ? " " : dueDates[0],
                paymentComplete: Number(
                  e.target.value > 100
                    ? 100
                    : e.target.value < 0
                    ? 0
                    : e.target.value
                ),
                terminationDate:
                  terminateDate[0] === null ? " " : terminateDate[0],
              });
            }
            setsplitedDueDates(dueDatesArr);
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Terminate date 1
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={terminateDate[0] === null ? " " : terminateDate[0]}
          onChange={(e) => {
            //for changing textbox date

            setterminateDate(dueDatesArr);
            if (splitedDueDates.length > 0) {
              dueDatesArr = splitedDueDates;
              dueDatesArr[0].terminationDate = e.target.value;
              setsplitedDueDates(dueDatesArr);
            } else {
              dueDatesArr.push({
                paymentDueDate: dueDates[0] === null ? " " : dueDates[0],
                paymentComplete:
                  dueDatePayment[0] === null ? 0 : dueDatePayment[0],
                terminationDate: e.target.value,
              });
              setsplitedDueDates(dueDatesArr);
            }
          }}
        />
      </CCol>
    </CRow>
  );
  let two = (
    <CRow className="mb-3">
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment due date 2
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={dueDates[1] === null ? " " : dueDates[1]}
          onChange={(e) => {
            //for changing textbox date

            if (splitedDueDates.length >= 2) {
              dueDatesArr = [];

              setdueDates(dueDatesArr);
              dueDatesArr = splitedDueDates;
              dueDatesArr[1].paymentDueDate = e.target.value;
              setsplitedDueDates(dueDatesArr);
            } else {
              dueDatesArr[1] = e.target.value;
              setdueDates(dueDatesArr);
              dueDatesArr = [];

              dueDatesArr.push(splitedDueDates[0], {
                paymentDueDate: e.target.value,
                paymentComplete:
                  dueDatePayment[1] === null ? 0 : dueDatePayment[1],
                terminationDate:
                  terminateDate[1] === null ? " " : terminateDate[1],
              });
              setsplitedDueDates(dueDatesArr);
            }
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment Complete
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          min="0"
          max="100"
          type="number"
          placeholder=""
          value={
            dueDatePayment[1] === null
              ? null
              : dueDatePayment[1] > 100
              ? 100
              : dueDatePayment[1] < 0
              ? 0
              : dueDatePayment[1]
          }
          onChange={(e) => {
            if (splitedDueDates.length >= 2) {
              if (e.target.value > 100) {
                dueDatesArr[1] = 100;
              } else if (e.target.value < 0) {
                dueDatesArr[1] = 0;
              } else {
                dueDatesArr = [];
              }

              setdueDatePayment(dueDatesArr);
              dueDatesArr = splitedDueDates;
              dueDatesArr[1].paymentComplete = Number(
                e.target.value > 100
                  ? 100
                  : e.target.value < 0
                  ? 0
                  : e.target.value
              );
            } else {
              if (e.target.value > 100) {
                dueDatesArr[1] = 100;
              } else if (e.target.value < 0) {
                dueDatesArr[1] = 0;
              } else {
                dueDatesArr = [];
              }

              setdueDatePayment(dueDatesArr);
              dueDatesArr = [];
              dueDatesArr.push(splitedDueDates[0], {
                paymentDueDate: dueDates[1] === null ? " " : dueDates[1],
                paymentComplete: Number(
                  e.target.value > 100
                    ? 100
                    : e.target.value < 0
                    ? 0
                    : e.target.value
                ),
                terminationDate:
                  terminateDate[1] === null ? " " : terminateDate[1],
              });
            }

            setsplitedDueDates(dueDatesArr);
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Terminate date 2
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={terminateDate[1] === null ? " " : terminateDate[1]}
          onChange={(e) => {
            //for changing textbox date

            if (splitedDueDates.length >= 2) {
              dueDatesArr = [];
              setterminateDate(dueDatesArr);
              dueDatesArr = splitedDueDates;
              dueDatesArr[1].terminationDate = e.target.value;
              setsplitedDueDates(dueDatesArr);
            } else {
              dueDatesArr[1] = e.target.value;
              setterminateDate(dueDatesArr);
              dueDatesArr = [];

              dueDatesArr.push(splitedDueDates[0], {
                paymentDueDate: dueDates[1] === null ? " " : dueDates[1],
                paymentComplete:
                  dueDatePayment[1] === null ? 0 : dueDatePayment[1],
                terminationDate: e.target.value,
              });
              setsplitedDueDates(dueDatesArr);
            }
          }}
        />
      </CCol>
    </CRow>
  );
  let three = (
    <CRow className="mb-3">
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment due date 3
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={dueDates[2] === null ? " " : dueDates[2]}
          onChange={(e) => {
            //for changing textbox date

            if (splitedDueDates.length >= 3) {
              dueDatesArr = [];
              setdueDates(dueDatesArr);
              dueDatesArr = splitedDueDates;
              dueDatesArr[2].paymentDueDate = e.target.value;
              setsplitedDueDates(dueDatesArr);
            } else {
              dueDatesArr[2] = e.target.value;
              setdueDates(dueDatesArr);
              dueDatesArr = [];
              dueDatesArr.push(splitedDueDates[0], splitedDueDates[1], {
                paymentDueDate: e.target.value,
                paymentComplete:
                  dueDatePayment[2] === null ? 0 : dueDatePayment[2],
                terminationDate:
                  terminateDate[2] === null ? " " : terminateDate[2],
              });
              setsplitedDueDates(dueDatesArr);
            }
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment Complete
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          min="0"
          max="100"
          type="number"
          value={
            dueDatePayment[2] === null
              ? null
              : dueDatePayment[2] > 100
              ? 100
              : dueDatePayment[2] < 0
              ? 0
              : dueDatePayment[2]
          }
          placeholder=""
          onChange={(e) => {
            if (splitedDueDates.length >= 3) {
              if (e.target.value > 100) {
                dueDatesArr[2] = 100;
              } else if (e.target.value < 0) {
                dueDatesArr[2] = 0;
              } else {
                dueDatesArr = [];
              }

              setdueDatePayment(dueDatesArr);
              dueDatesArr = splitedDueDates;
              dueDatesArr[2].paymentComplete = Number(
                e.target.value > 100
                  ? 100
                  : e.target.value < 0
                  ? 0
                  : e.target.value
              );
            } else {
              if (e.target.value > 100) {
                dueDatesArr[2] = 100;
              } else if (e.target.value < 0) {
                dueDatesArr[2] = 0;
              } else {
                dueDatesArr = [];
              }

              setdueDatePayment(dueDatesArr);
              dueDatesArr = [];
              dueDatesArr.push(splitedDueDates[0], splitedDueDates[1], {
                paymentDueDate: dueDates[2] === null ? " " : dueDates[2],
                paymentComplete: Number(
                  e.target.value > 100
                    ? 100
                    : e.target.value < 0
                    ? 0
                    : e.target.value
                ),
                terminationDate:
                  terminateDate[2] === null ? " " : terminateDate[2],
              });
            }

            setsplitedDueDates(dueDatesArr);
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Terminate date 3
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={terminateDate[2] === null ? " " : terminateDate[2]}
          onChange={(e) => {
            //for changing textbox date

            if (splitedDueDates.length >= 3) {
              dueDatesArr = [];
              setterminateDate(dueDatesArr);
              dueDatesArr = splitedDueDates;
              dueDatesArr[2].terminationDate = e.target.value;
              setsplitedDueDates(dueDatesArr);
            } else {
              dueDatesArr[2] = e.target.value;
              setterminateDate(dueDatesArr);
              dueDatesArr = [];
              dueDatesArr.push(splitedDueDates[0], splitedDueDates[1], {
                paymentDueDate: dueDates[2] === null ? " " : dueDates[2],
                paymentComplete:
                  dueDatePayment[2] === null ? 0 : dueDatePayment[2],
                terminationDate: e.target.value,
              });
              setsplitedDueDates(dueDatesArr);
            }
          }}
        />
      </CCol>
    </CRow>
  );
  let four = (
    <CRow className="mb-3">
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment due date 4
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={dueDates[3] === null ? " " : dueDates[3]}
          onChange={(e) => {
            //for changing textbox date
            if (splitedDueDates.length >= 4) {
              dueDatesArr = [];

              setdueDates(dueDatesArr);
              dueDatesArr = splitedDueDates;
              dueDatesArr[3].paymentDueDate = e.target.value;
              setsplitedDueDates(dueDatesArr);
            } else {
              dueDatesArr[3] = e.target.value;
              setdueDates(dueDatesArr);
              dueDatesArr = [];

              dueDatesArr.push(
                splitedDueDates[0],
                splitedDueDates[1],
                splitedDueDates[2],
                {
                  paymentDueDate: e.target.value,
                  paymentComplete:
                    dueDatePayment[3] === null ? 0 : dueDatePayment[3],
                  terminationDate:
                    terminateDate[3] === null ? " " : terminateDate[3],
                }
              );
              setsplitedDueDates(dueDatesArr);
            }
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment Complete
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          min="0"
          max="100"
          type="number"
          value={
            dueDatePayment[3] === null
              ? null
              : dueDatePayment[3] > 100
              ? 100
              : dueDatePayment[3] < 0
              ? 0
              : dueDatePayment[3]
          }
          placeholder=""
          onChange={(e) => {
            if (splitedDueDates.length >= 4) {
              if (e.target.value > 100) {
                dueDatesArr[3] = 100;
              } else if (e.target.value < 0) {
                dueDatesArr[3] = 0;
              } else {
                dueDatesArr = [];
              }

              setdueDatePayment(dueDatesArr);
              dueDatesArr = splitedDueDates;
              dueDatesArr[3].paymentComplete = Number(
                e.target.value > 100
                  ? 100
                  : e.target.value < 0
                  ? 0
                  : e.target.value
              );
            } else {
              if (e.target.value > 100) {
                dueDatesArr[3] = 100;
              } else if (e.target.value < 0) {
                dueDatesArr[3] = 0;
              } else {
                dueDatesArr = [];
              }

              setdueDatePayment(dueDatesArr);
              dueDatesArr = [];
              dueDatesArr.push(
                splitedDueDates[0],
                splitedDueDates[1],
                splitedDueDates[2],
                {
                  paymentDueDate: dueDates[3] === null ? " " : dueDates[3],
                  paymentComplete: Number(
                    e.target.value > 100
                      ? 100
                      : e.target.value < 0
                      ? 0
                      : e.target.value
                  ),
                  terminationDate:
                    terminateDate[3] === null ? " " : terminateDate[3],
                }
              );
            }

            setsplitedDueDates(dueDatesArr);
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Terminate date 4
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={terminateDate[3] === null ? " " : terminateDate[3]}
          onChange={(e) => {
            //for changing textbox date
            if (splitedDueDates.length >= 4) {
              dueDatesArr = [];

              setterminateDate(dueDatesArr);
              dueDatesArr = splitedDueDates;
              dueDatesArr[3].terminationDate = e.target.value;
              setsplitedDueDates(dueDatesArr);
            } else {
              dueDatesArr[3] = e.target.value;
              setterminateDate(dueDatesArr);
              dueDatesArr = [];

              dueDatesArr.push(
                splitedDueDates[0],
                splitedDueDates[1],
                splitedDueDates[2],
                {
                  paymentDueDate: dueDates[3] === null ? " " : dueDates[3],
                  paymentComplete:
                    dueDatePayment[3] === null ? 0 : dueDatePayment[3],
                  terminationDate: e.target.value,
                }
              );
              setsplitedDueDates(dueDatesArr);
            }
          }}
        />
      </CCol>
    </CRow>
  );
  let five = (
    <CRow className="mb-3">
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment due date 5
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={dueDates[4] === null ? " " : dueDates[4]}
          onChange={(e) => {
            //for changing textbox date
            if (splitedDueDates.length === 5) {
              dueDatesArr = [];

              setdueDates(dueDatesArr);
              dueDatesArr = splitedDueDates;
              dueDatesArr[4].paymentDueDate = e.target.value;
              setsplitedDueDates(dueDatesArr);
            } else {
              dueDatesArr[4] = e.target.value;
              setdueDates(dueDatesArr);
              dueDatesArr = [];

              dueDatesArr.push(
                splitedDueDates[0],
                splitedDueDates[1],
                splitedDueDates[2],
                splitedDueDates[3],
                {
                  paymentDueDate: e.target.value,
                  paymentComplete:
                    dueDatePayment[4] === null ? 0 : dueDatePayment[4],
                  terminationDate:
                    terminateDate[4] === null ? " " : terminateDate[4],
                }
              );
              setsplitedDueDates(dueDatesArr);
            }
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Payment Complete
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          min="0"
          max="100"
          type="number"
          value={
            dueDatePayment[4] === null
              ? null
              : dueDatePayment[4] > 100
              ? 100
              : dueDatePayment[4] < 0
              ? 0
              : dueDatePayment[4]
          }
          placeholder=""
          onChange={(e) => {
            if (splitedDueDates.length === 5) {
              if (e.target.value > 100) {
                dueDatesArr[4] = 100;
              } else if (e.target.value < 0) {
                dueDatesArr[4] = 0;
              } else {
                dueDatesArr = [];
              }

              setdueDatePayment(dueDatesArr);
              dueDatesArr = splitedDueDates;
              dueDatesArr[4].paymentComplete = Number(
                e.target.value > 100
                  ? 100
                  : e.target.value < 0
                  ? 0
                  : e.target.value
              );
            } else {
              if (e.target.value > 100) {
                dueDatesArr[4] = 100;
              } else if (e.target.value < 0) {
                dueDatesArr[4] = 0;
              } else {
                dueDatesArr = [];
              }

              setdueDatePayment(dueDatesArr);
              dueDatesArr = [];
              dueDatesArr.push(
                splitedDueDates[0],
                splitedDueDates[1],
                splitedDueDates[2],
                splitedDueDates[3],
                {
                  paymentDueDate: dueDates[4] === null ? " " : dueDates[4],
                  paymentComplete: Number(
                    e.target.value > 100
                      ? 100
                      : e.target.value < 0
                      ? 0
                      : e.target.value
                  ),
                  terminationDate:
                    terminateDate[4] === null ? " " : terminateDate[4],
                }
              );
            }

            setsplitedDueDates(dueDatesArr);
          }}
        />
      </CCol>
      <CCol xl={2}>
        <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
          Terminate date 5
        </CLabel>
      </CCol>
      <CCol xl={2}>
        <CInput
          type="date"
          placeholder=""
          value={terminateDate[4] === null ? " " : terminateDate[4]}
          onChange={(e) => {
            //for changing textbox date
            if (splitedDueDates.length === 5) {
              dueDatesArr = [];

              setterminateDate(dueDatesArr);
              dueDatesArr = splitedDueDates;
              dueDatesArr[4].terminationDate = e.target.value;
              setsplitedDueDates(dueDatesArr);
            } else {
              dueDatesArr[4] = e.target.value;
              setterminateDate(dueDatesArr);
              dueDatesArr = [];

              dueDatesArr.push(
                splitedDueDates[0],
                splitedDueDates[1],
                splitedDueDates[2],
                splitedDueDates[3],
                {
                  paymentDueDate: dueDates[4] === null ? " " : dueDates[4],
                  paymentComplete:
                    dueDatePayment[4] === null ? 0 : dueDatePayment[4],
                  terminationDate: e.target.value,
                }
              );
              setsplitedDueDates(dueDatesArr);
            }
          }}
        />
      </CCol>
    </CRow>
  );
  return (
    <>
      <CCardHeader className="mb-3">
        <CRow xl={12} className="pt-3 ">
          <CCol xl={10}>
            <h3> {mode === "view" ? "Tender Details" : "Update Tender"} </h3>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CForm onSubmit={postTenderData}>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                Tender number
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="text"
                placeholder=""
                value={tenderNo === null ? " " : tenderNo}
                onChange={(e) => settenderNo(e.target.value)}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                Details
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="text"
                placeholder=""
                value={details === null ? " " : details}
                onChange={(e) => {
                  setdetails(e.target.value);
                }}
              />
            </CCol>
          </CRow>{" "}
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                Purchase Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={purchaseDate === null ? " " : purchaseDate}
                onChange={(e) => {
                  setPurchaseDate(e.target.value);
                }}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                Payment Slots
              </CLabel>
            </CCol>
            <CCol xl={2}>
              {/* <CInput
                type="number"
                placeholder=""
                value={paymentSlots === null ? " " : paymentSlots}
                onChange={(e) => setpaymentSlots(e.target.value)}
              /> */}
              <CSelect
                aria-label="Default select example"
                onChange={(e) => {
                  setpaymentSlots(e.target.value);
                  if (splitedDueDates.length > e.target.value) {
                    dueDatesArr = splitedDueDates;
                    dueDatesArr.splice(
                      e.target.value,
                      splitedDueDates.length - e.target.value
                    );
                    setsplitedDueDates(dueDatesArr);
                  }
                }}
                value={paymentSlots === null ? " " : paymentSlots}
              >
                <option>Select Slots</option>
                <option value={1}>1</option>
                <option value={2}>2</option>
                <option value={3}>3</option>
                <option value={4}>4</option>
                <option value={5}>5</option>
              </CSelect>
            </CCol>
          </CRow>
          {paymentSlots === 1 ? (
            one
          ) : paymentSlots === 5 ? (
            <>
              {one}
              {two}
              {three}
              {four}
              {five}
            </>
          ) : paymentSlots === 2 ? (
            <>
              {one}
              {two}
            </>
          ) : paymentSlots === 3 ? (
            <>
              {one}
              {two}
              {three}
            </>
          ) : paymentSlots === 4 ? (
            <>
              {one}
              {two}
              {three}
              {four}
            </>
          ) : (
            <></>
          )}
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                Rebate
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="text"
                placeholder=""
                value={rebate === null ? " " : rebate}
                onChange={(e) => setrebate(e.target.value)}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                Late Fee Per Day
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="number"
                placeholder=""
                value={lateFeePerDay === null ? " " : lateFeePerDay}
                onChange={(e) => setlateFeePerDay(e.target.value)}
              />
            </CCol>
          </CRow>{" "}
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                Security Deposit Amount:
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="text"
                placeholder=""
                value={
                  securityDepositAmount === null ? " " : securityDepositAmount
                }
                onChange={(e) => setsecurityDepositAmount(e.target.value)}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                Security Deposit Day:
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="text"
                placeholder=""
                value={securityDepositDay === null ? " " : securityDepositDay}
                onChange={(e) => setsecurityDepositDay(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom03"
                className="col-sm-12 col-form-label"
              >
                Collection Season
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CSelect
                value={collectionSeason === null ? " " : collectionSeason}
                id="validationCustom03"
                onChange={(e) => setcollectionSeason(e.target.value)}
              >
                {Array.from(new Array(200), (v, i) => (
                  <option key={i} value={year + i}>
                    {year + i}
                  </option>
                ))}
              </CSelect>
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom03"
                className="col-sm-12 col-form-label"
              >
                Lease Period Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={leasePeriodDate === null ? "" : leasePeriodDate}
                id="validationCustom03"
                onChange={(e) => setleasePeriodDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom03"
                className="col-sm-12 col-form-label"
              >
                Tender Type
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CSelect
                value={TenderTypes}
                aria-label="Default select example"
                onChange={(e) => setTenderTypes(e.target.value)}
              >
                <option value={0} selected={true}>
                  Select Tender Type
                </option>
                <option value={1}>Advanced Tender</option>
                <option value={2}>Godown Tender</option>
                <option value={3}>MSP</option>
              </CSelect>
            </CCol>
          </CRow>
          <hr />
          <CRow xl={12} className="pt-3 ">
            <CCol xl={10}>
              <h3>Agreement Details</h3>
            </CCol>
          </CRow>
          <hr />
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom20"
                className="col-sm-12 col-form-label"
              >
                Period Ending Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={periodEndingDate === null ? " " : periodEndingDate}
                id="validationCustom20"
                onChange={(e) => setperiodEndingDate(e.target.value)}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom21"
                className="col-sm-12 col-form-label"
              >
                Representative Details Submission Last Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={
                  representativeDetailsLastDate === null
                    ? " "
                    : representativeDetailsLastDate
                }
                id="validationCustom21"
                onChange={(e) =>
                  setrepresentativeDetailsLastDate(e.target.value)
                }
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom04"
                className="col-sm-12 col-form-label"
              >
                Agreement Start Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={AgreementStartDate === null ? " " : AgreementStartDate}
                id="validationCustom04"
                onChange={(e) => setAgreementStartDate(e.target.value)}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom04"
                className="col-sm-12 col-form-label"
              >
                Agreement Upto Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={AgreementUptoDate === null ? " " : AgreementUptoDate}
                id="validationCustom04"
                onChange={(e) => setAgreementUptoDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom22"
                className="col-sm-12 col-form-label"
              >
                Distt Union Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={paymentLastDate === null ? " " : paymentLastDate}
                id="validationCustom22"
                onChange={(e) => setpaymentLastDate(e.target.value)}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom23"
                className="col-sm-12 col-form-label"
              >
                Double Lock Upto Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={doubleLockUptoDate === null ? " " : doubleLockUptoDate}
                id="validationCustom23"
                onChange={(e) => setdoubleLockUptoDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom24"
                className="col-sm-12 col-form-label"
              >
                Through Letter Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={throughLetterDate === null ? " " : throughLetterDate}
                id="validationCustom24"
                onChange={(e) => setthroughLetterDate(e.target.value)}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom25"
                className="col-sm-12 col-form-label"
              >
                Keeping In Godown Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={keepingInGodownDate === null ? " " : keepingInGodownDate}
                id="validationCustom25"
                onChange={(e) => setkeepingInGodownDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom04"
                className="col-sm-12 col-form-label"
              >
                Godown Insurace Date From
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={
                  godownInsuraceFromDate === null ? " " : godownInsuraceFromDate
                }
                id="validationCustom04"
                onChange={(e) => setGodownInsuraceFromDate(e.target.value)}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom04"
                className="col-sm-12 col-form-label"
              >
                Godown Insurace Date To
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={
                  godownInsuraceToDate === null ? " " : godownInsuraceToDate
                }
                id="validationCustom04"
                onChange={(e) => setGodownInsuraceToDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className=" mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom05"
                className="col-sm-12 col-form-label"
              >
                Last Date For Submitting Insurance Policy
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={
                  lastDateForSubmittingInsurancePolicy === null
                    ? " "
                    : lastDateForSubmittingInsurancePolicy
                }
                id="validationCustom05"
                onChange={(e) =>
                  setLastDateForSubmittingInsurancePolicy(e.target.value)
                }
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom06"
                className="col-sm-12 col-form-label"
              >
                Extra Amount Insurance LastDate
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={
                  extraAmountInsuranceLastDate === null
                    ? " "
                    : extraAmountInsuranceLastDate
                }
                id="validationCustom06"
                onChange={(e) =>
                  setExtraAmountInsuranceLastDate(e.target.value)
                }
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom07"
                className="col-sm-12 col-form-label"
              >
                Late Fee Insurance Amount
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="text"
                placeholder=""
                value={
                  lateFeeInsuranceAmount === null ? " " : lateFeeInsuranceAmount
                }
                id="validationCustom07"
                onChange={(e) => setLateFeeInsuranceAmount(e.target.value)}
              />
            </CCol>
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom08"
                className="col-sm-12 col-form-label"
              >
                Restoration Fee
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="number"
                placeholder=""
                value={RestorationFee === null ? " " : RestorationFee}
                id="validationCustom08"
                onChange={(e) => setRestorationFee(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom09"
                className="col-sm-12 col-form-label"
              >
                Penalty Amount
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="number"
                placeholder=""
                value={penaltyAmount === null ? " " : penaltyAmount}
                id="validationCustom09"
                onChange={(e) => {
                  setPenaltyAmount(e.target.value);
                }}
              />
            </CCol>
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom14"
                className="col-sm-12 col-form-label"
              >
                Termination Late Fee Per Day
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="text"
                placeholder=""
                value={
                  TerminationLateFeePerDay === null
                    ? " "
                    : TerminationLateFeePerDay
                }
                id="validationCustom14"
                onChange={(e) => setTerminationLateFeePerDay(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom10"
                className="col-sm-12 col-form-label"
              >
                Termination Agreement Start Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={
                  TerminationAgreementStartDate === null
                    ? " "
                    : TerminationAgreementStartDate
                }
                id="validationCustom10"
                onChange={(e) =>
                  setTerminationAgreementStartDate(e.target.value)
                }
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom11"
                className="col-sm-12 col-form-label"
              >
                Termination Agreement End Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={
                  TerminationAgreementEndDate === null
                    ? " "
                    : TerminationAgreementEndDate
                }
                id="validationCustom11"
                onChange={(e) => setTerminationAgreementEndDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom12"
                className="col-sm-12 col-form-label"
              >
                After Termination Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={
                  AfterTerminationDate === null ? " " : AfterTerminationDate
                }
                id="validationCustom12"
                onChange={(e) => setAfterTerminationDate(e.target.value)}
              />
            </CCol>

            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom13"
                className="col-sm-12 col-form-label"
              >
                Termination UpTo Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={TerminationUpToDate === null ? " " : TerminationUpToDate}
                id="validationCustom13"
                onChange={(e) => setTerminationUpToDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom15"
                className="col-sm-12 col-form-label"
              >
                Pruning Start Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={PruningStartDate === null ? " " : PruningStartDate}
                id="validationCustom15"
                onChange={(e) => setPruningStartDate(e.target.value)}
              />
            </CCol>
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom16"
                className="col-sm-12 col-form-label"
              >
                Pruning End Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={PruningEndDate === null ? " " : PruningEndDate}
                id="validationCustom16"
                onChange={(e) => setPruningEndDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom26"
                className="col-sm-12 col-form-label"
              >
                Godown Rent Payment Upto Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={
                  godownRentPaymentUptoDate === null
                    ? " "
                    : godownRentPaymentUptoDate
                }
                id="validationCustom26"
                onChange={(e) => setgodownRentPaymentUptoDate(e.target.value)}
              />
            </CCol>
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom27"
                className="col-sm-12 col-form-label"
              >
                Second Agreement Extension Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={
                  secondAgreementExtentionDate === null
                    ? " "
                    : secondAgreementExtentionDate
                }
                id="validationCustom27"
                onChange={(e) =>
                  setsecondAgreementExtentionDate(e.target.value)
                }
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom28"
                className="col-sm-12 col-form-label"
              >
                Additional SD Last Date:
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={
                  additionalSDLastDate === null ? " " : additionalSDLastDate
                }
                id="validationCustom28"
                onChange={(e) => setadditionalSDLastDate(e.target.value)}
              />
            </CCol>
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom29"
                className="col-sm-12 col-form-label"
              >
                GoDown Rent per Bag
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="number"
                placeholder="0"
                value={godownRentPerBag}
                id="validationCustom29"
                onChange={(e) => setGodownRentPerBag(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom30"
                className="col-sm-12 col-form-label"
              >
                HSN:
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="text"
                maxLength={100}
                placeholder=""
                value={HSN === null ? "" : HSN}
                id="validationCustom30"
                onChange={(e) => setHSN(e.target.value)}
              />
            </CCol>
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom31"
                className="col-sm-12 col-form-label"
              >
                Cheque Replacement Last Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={ChequeReplacementLastDate}
                id="validationCustom31"
                onChange={(e) => setChequeReplacementLastDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom32"
                className="col-sm-12 col-form-label"
              >
                First Transfer Last Date:
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={FirstTransferLastDate}
                id="validationCustom32"
                onChange={(e) => setFirstTransferLastDate(e.target.value)}
              />
            </CCol>
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom33"
                className="col-sm-12 col-form-label"
              >
                Second Transfer Start Date
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={SecondTransferStartDate}
                id="validationCustom33"
                onChange={(e) => setSecondTransferStartDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom34"
                className="col-sm-12 col-form-label"
              >
                Second Transfer End Date:
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                value={SecondTransferEndDate}
                id="validationCustom34"
                onChange={(e) => setSecondTransferEndDate(e.target.value)}
              />
            </CCol>
          </CRow>
          <hr />
          <CRow xl={12} className="pt-3 ">
            <CCol xl={10}>
              <h3>Sanction Details</h3>
            </CCol>
          </CRow>
          <hr />
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                Clause
              </CLabel>
            </CCol>
            <CCol xl={4}>
              <span>{`Lease period upto {{Lease Period date will appear here}}`}</span>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}></CCol>{" "}
            <CCol xl={6}>
              <span>{`The due dates of the payment of instalments are {{Payment Installment date will appear here}}.`}</span>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}></CCol>
            <CCol xl={4}>
              <CTextarea
                rows="2"
                value={clauseData === null ? "" : clauseData}
                onChange={(e) => {
                  setclauseData(e.target.value);
                }}
              />
            </CCol>
            <CCol xl={2}>
              <CButton
                onClick={() => {
                  let click = clauseSlots;
                  setclauseSlots(click + 1);
                  if (clauseId.length === 0) {
                    const newclause = [
                      ...clausesData,
                      { id: click + 1, clause: "" },
                    ];
                    setclauseId([...clauseId, click + 1]);
                    setclausesData(newclause);
                  } else {
                    const newclause = [
                      ...clausesData,
                      { id: clauseId[clauseId.length - 1] + 1, clause: "" },
                    ];
                    setclauseId([
                      ...clauseId,
                      clauseId[clauseId.length - 1] + 1,
                    ]);

                    setclausesData(newclause);
                  }
                }}
                color="success"
              >
                +
              </CButton>
            </CCol>
          </CRow>
          {[...Array(clausesData.length)].map((e, i) => (
            <>
              <CRow className="mb-3">
                <CCol xl={2}></CCol>
                <CCol xl={4}>
                  <CTextarea
                    rows="2"
                    key={`key-input ${i}`}
                    value={
                      clausesData[i].clause === null
                        ? ""
                        : clausesData[i].clause
                    }
                    onChange={(e) => {
                      setclausesData((prev) =>
                        prev.map((item) =>
                          item.id === clauseId[i]
                            ? { id: clauseId[i], clause: e.target.value }
                            : item
                        )
                      );
                    }}
                  />
                </CCol>
                <CCol xl={1}>
                  <CButton
                    color="danger"
                    onClick={(e) => {
                      if (clausesData.length === 1) {
                        setclausesData([]);
                        setclauseId([]);
                        setclauseSlots(0);
                      } else {
                        const removedArr = [...clausesData].filter(
                          (clause) => clause.id !== clauseId[i]
                        );
                        setclausesData(removedArr);
                        const removedId = [...clauseId].filter(
                          (id) => id !== clauseId[i]
                        );
                        setclauseId(removedId);
                        setclauseSlots(clauseSlots - 1);
                      }
                    }}
                  >
                    -
                  </CButton>
                </CCol>
              </CRow>
            </>
          ))}
          {/* <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                Can Modified
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <input
                type="checkbox"
                checked={canModified ? true : false}
                onChange={() => setcanModified(!canModified)}
              />
            </CCol>
          </CRow> */}
          <CRow className="mb-3">
            <CCol xl={4}>
              {loading ? (
                <CSpinner className="spinner-grow" color="success" />
              ) : (
                <div>
                  <CButton
                    className="ml-3"
                    color="success"
                    onClick={() => history.goBack()}
                  >
                    Go Back
                  </CButton>
                  <CButton
                    className="ml-3"
                    color="success"
                    hidden={mode === "view" ? true : false}
                    type="submit"
                  >
                    Update
                  </CButton>
                  <CButton
                    className="ml-3"
                    color="danger"
                    to={
                      authenticated.role === "CGMF"
                        ? "/tender/tenderlist"
                        : "/tenderlist"
                    }
                  >
                    Cancel
                  </CButton>
                </div>
              )}
            </CCol>
          </CRow>
        </CForm>
      </CCardBody>
    </>
  );
};
export default EditTender;
